import { render, staticRenderFns } from "./PTopHeroVideo.vue?vue&type=template&id=392789b8&"
import script from "./PTopHeroVideo.vue?vue&type=script&lang=js&"
export * from "./PTopHeroVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports